import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AdditionalInformationWidgetComponent } from
  '@feature/_app_modules/additional-information/components/additional-information-widget/additional-information-widget.component';
import { AdditionalInformationHttpService } from '@feature/_app_modules/additional-information/services/additional-information-http.service';
import { AdditionalInformationEffects } from '@feature/_app_modules/additional-information/effects/additional-information.effects';
import { AdditionalInformationAvailableGroupsEffects } from '@feature/_app_modules/additional-information/effects/additional-information-available-groups.effects';
import * as AdditionalInformationReducers from '../additional-information/reducers/additional-information.reducers';
import * as AdditionalInformationAvailableGroupsReducers from '../additional-information/reducers/additional-information-available-groups.reducers';
import { AdditionalInformationFacadeService } from
  "@feature/_app_modules/additional-information/services/additional-information-facade.service";
import { AdditionalInformationEditDialogComponent } from '@feature/_app_modules/additional-information/components/additional-information-widget/additional-information-edit-dialog.component'

@NgModule({
  declarations: [
    AdditionalInformationWidgetComponent,
    AdditionalInformationEditDialogComponent
  ],
  exports: [
    AdditionalInformationWidgetComponent,
    AdditionalInformationEditDialogComponent
    ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('AdditionalInformation', AdditionalInformationReducers.reducer),
    StoreModule.forFeature('AdditionalInformationAvailableGroups', AdditionalInformationAvailableGroupsReducers.reducer),
    EffectsModule.forFeature([AdditionalInformationEffects, AdditionalInformationAvailableGroupsEffects])
    ],
  providers: [
    AdditionalInformationHttpService,
    AdditionalInformationFacadeService
  ]
})
export class AdditionalInformationWidgetModule { }
